import React, { useState } from 'react';
import { Alert, Button, Collapse, Spin, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { PendingApprovalRow } from '@/services/salesDashboard.service';

export const ApprovalStrip: React.FC<{
  rows: PendingApprovalRow[];
  loading?: boolean;
  error?: string | null;
}> = ({ rows, loading, error }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(rows.length > 0);

  if (loading) return <Spin size="small" />;
  if (error) return <Alert type="warning" message={error} showIcon />;
  if (!rows.length) return null;

  return (
    <Alert
      type="info"
      showIcon
      message={
        <Button type="link" style={{ padding: 0 }} onClick={() => setOpen(!open)}>
          Awaiting your approval: {rows.length} item{rows.length === 1 ? '' : 's'}
        </Button>
      }
      description={
        open ? (
          <Collapse
            ghost
            defaultActiveKey={rows.map((r) => r.approval_instance_id)}
            items={rows.map((r) => ({
              key: r.approval_instance_id,
              label: (
                <span>
                  <Tag>{r.entity_type}</Tag> {r.document_number || r.entity_id}
                </span>
              ),
              children: (
                <Button type="primary" size="small" onClick={() => navigate(r.link_path)}>
                  Review
                </Button>
              ),
            }))}
          />
        ) : null
      }
    />
  );
};
